// @flow
import * as React from 'react';
import styled from 'styled-components';
import Box from 'components/Box';
import { AnimatedCheckmark } from 'components/Icon';
import Logo from 'components/Logo';
// import Button from 'components/Button';
import type { HeaderProps } from './Header';
import { colors, transition } from '../../../theme';

export type Props = HeaderProps & {
  logo?: React.Node
};

const Step = styled(({ active, complete, index, ...props }) => (
  <Box
    display="flex"
    width={24}
    height={24}
    alignItems="center"
    justifyContent="center"
    borderRadius="50%"
    fontSize={12}
    transition={`all ${transition}`}
    {...props}
  >
    {complete ? <AnimatedCheckmark stroke="currentColor" /> : index + 1}
  </Box>
)).attrs(({ complete, active }) => ({
  style: {
    backgroundColor: complete ? colors.waterBlue : 'transparent',
    color: complete ? 'white' : active ? colors.waterBlue : colors.greyishBrown,
    boxShadow: `0 0 0 2px ${
      active || complete ? colors.waterBlue : colors.aluminum
    } inset`
  }
}))`
  /* stylelint */
`;

const StepLine = styled(({ complete, ...props }) => (
  <Box
    position="relative"
    mx="4px"
    height="2px"
    width={[25, 50]}
    overflow="hidden"
    bg={colors.silver}
    {...props}
  />
))`
  &::before {
    content: '';
    position: absolute;
    right: 100%;
    width: 100%;
    height: 100%;
    background: ${colors.waterBlue};
    transform: translateX(${props => (props.complete ? '100%' : 0)});
    transition: all ${transition};
  }
`;

const SmallHeader = ({
  steps,
  currentStep,
  // goBackToStep,
  // errors,
  logo
}: Props) => {
  const visibleSteps = steps
    .map((step, index) => ({ ...step, index }))
    .filter(step => !step.ignoreInNav);

  return (
    <Box
      height={[60, null, null, 100]}
      py={[16, null, null, 24]}
      display="flex"
      justifyContent="space-between"
      borderBottom={`1px solid ${colors.aluminum}`}
    >
      <Box>{logo || <Logo height={[28, null, null, 52]} />}</Box>

      {visibleSteps.length > 1 && (
        <Box display="flex" alignItems="center">
          {visibleSteps.map((step, index) => (
            <React.Fragment
              // eslint-disable-next-line react/no-array-index-key
              key={step.index}
            >
              <Step
                active={currentStep === step.index}
                complete={currentStep > step.index}
                index={index}
              />
              {index < visibleSteps.length - 1 && (
                <StepLine complete={currentStep > step.index} />
              )}
            </React.Fragment>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default SmallHeader;
